import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

const sections = [
  {
    title: "Éditeur du site",
    body: "Le site La Bascule est édité par la société CADAKADEMI, SAS au capital de 1 000 €, immatriculée sous le SIREN 907 970 479 (SIRET siège : 907 970 479 00016), dont le siège social est situé Tour Mercure, 445 boulevard Gambetta, 59200 Tourcoing. Activité : formation continue d'adultes (code APE 85.59A). Contact : contact@labascule.fr. Directeur de la publication : Simon Cadart.",
  },
  {
    title: "Hébergement",
    body: "Le site est hébergé sur l'infrastructure Emergent.sh. Les données sont stockées de manière sécurisée et ne sont jamais cédées à des tiers à des fins commerciales.",
  },
  {
    title: "Données personnelles (RGPD)",
    body: "Les données collectées via les formulaires (newsletter, candidature) sont utilisées exclusivement pour : l'envoi de la newsletter La Bascule et le traitement des candidatures à l'accompagnement. Conformément au RGPD, tu disposes d'un droit d'accès, de rectification et de suppression de tes données : il suffit d'écrire à contact@labascule.fr. La newsletter est gérée via MailerLite ; la désinscription est possible en un clic depuis chaque email.",
  },
  {
    title: "Cookies",
    body: "Le site n'utilise pas de cookie publicitaire. Des cookies techniques peuvent être utilisés pour le bon fonctionnement du site et de l'espace administrateur.",
  },
  {
    title: "Propriété intellectuelle",
    body: "L'ensemble des contenus du site (textes, méthodes, éléments graphiques) est la propriété exclusive de la société CADAKADEMI. Toute reproduction sans autorisation écrite est interdite.",
  },
];

export default function MentionsLegales() {
  return (
    <div data-testid="legal-page" className="bg-[#0A0C10]">
      <Navbar />
      <section className="pt-40 pb-24">
        <div className="container-site max-w-3xl">
          <p className="eyebrow mb-4">Conformité</p>
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mb-14">
            Mentions légales & confidentialité
          </h1>
          <div className="space-y-8">
            {sections.map((s, i) => (
              <div key={i} data-testid={`legal-section-${i}`} className="glass-card p-8">
                <h2 className="font-heading text-lg font-bold mb-3 text-primary">{s.title}</h2>
                <p className="text-sm text-slate-400 leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
